import * as React from 'react';
import { SVGProps } from 'react';

const SvgNotFound = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    width={196}
    height={196}
    viewBox="0 0 196 196"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    {...props}
  >
    <g clipPath="url(#not-found_svg__a)">
      <rect width={196} height={196} rx={98} fill="#fff" />
      <circle cx={98} cy={98} r={98} fill="#FFE8E8" />
      <rect
        x={110.573}
        y={63.237}
        width={11.331}
        height={3.022}
        rx={1.511}
        transform="rotate(20 110.573 63.237)"
        fill="#E8ECEE"
      />
      <rect
        x={93.52}
        y={110.088}
        width={11.331}
        height={3.022}
        rx={1.511}
        transform="rotate(20 93.52 110.088)"
        fill="#E8ECEE"
      />
      <g filter="url(#not-found_svg__b)">
        <path
          d="M48.695 59.442a4 4 0 0 1 3.244-4.634l43.332-7.64 27.803 19.467 11.808 66.967a4 4 0 0 1-3.245 4.634L68.609 149.35a4 4 0 0 1-4.633-3.245L48.695 59.442Z"
          fill="#fff"
        />
        <path d="M123.074 66.635 95.271 47.168l3.473 19.696a4 4 0 0 0 4.634 3.244l19.696-3.473Z" fill="#DCE1E4" />
      </g>
      <rect x={57.789} y={64.946} width={33} height={3} rx={1.5} transform="rotate(-10 57.789 64.946)" fill="#DCE1E4" />
      <rect x={64.677} y={98.256} width={54} height={3} rx={1.5} transform="rotate(-10 64.677 98.256)" fill="#DCE1E4" />
      <rect x={66.933} y={108.52} width={38} height={3} rx={1.5} transform="rotate(-10 66.933 108.52)" fill="#DCE1E4" />
      <rect x={63.46} y={88.824} width={38} height={3} rx={1.5} transform="rotate(-10 63.46 88.824)" fill="#DCE1E4" />
      <rect
        x={68.669}
        y={118.369}
        width={42}
        height={3}
        rx={1.5}
        transform="rotate(-10 68.67 118.369)"
        fill="#DCE1E4"
      />
      <rect x={59.178} y={72.825} width={15} height={3} rx={1.5} transform="rotate(-10 59.178 72.825)" fill="#DCE1E4" />
      <rect
        x={69.944}
        y={133.883}
        width={15}
        height={3}
        rx={1.5}
        transform="rotate(-10 69.944 133.883)"
        fill="#DCE1E4"
      />
      <g filter="url(#not-found_svg__c)">
        <path
          d="M73.945 49.118a4 4 0 0 1 4.27-3.711l43.892 3.069 22.268 25.616-4.744 67.834a4 4 0 0 1-4.269 3.711l-63.844-4.464a4 4 0 0 1-3.711-4.27l6.138-87.785Z"
          fill="#fff"
        />
        <path d="m144.375 74.092-22.268-25.616-1.395 19.951a4 4 0 0 0 3.711 4.27l19.952 1.395Z" fill="#DCE1E4" />
      </g>
      <rect x={81.438} y={56.659} width={33} height={3} rx={1.5} transform="rotate(4 81.438 56.659)" fill="#DCE1E4" />
      <rect x={80.063} y={90.646} width={54} height={3} rx={1.5} transform="rotate(4 80.063 90.646)" fill="#DCE1E4" />
      <rect x={79.769} y={101.151} width={38} height={3} rx={1.5} transform="rotate(4 79.769 101.151)" fill="#DCE1E4" />
      <rect x={81.164} y={81.2} width={38} height={3} rx={1.5} transform="rotate(4 81.164 81.2)" fill="#DCE1E4" />
      <rect x={79.071} y={111.126} width={42} height={3} rx={1.5} transform="rotate(4 79.071 111.126)" fill="#DCE1E4" />
      <rect x={80.879} y={64.639} width={15} height={3} rx={1.5} transform="rotate(4 80.88 64.64)" fill="#DCE1E4" />
      <rect x={76.555} y={126.488} width={15} height={3} rx={1.5} transform="rotate(4 76.555 126.488)" fill="#DCE1E4" />
      <circle cx={131.5} cy={136.5} r={16} fill="#C03" />
      <g clipPath="url(#not-found_svg__d)">
        <path
          d="m139.3 141.026-6.317-11.646a1.67 1.67 0 0 0-.683-.68 1.693 1.693 0 0 0-2.284.68l-6.316 11.646a1.675 1.675 0 0 0 .039 1.66 1.677 1.677 0 0 0 1.447.814h12.628a1.703 1.703 0 0 0 1.308-.615 1.688 1.688 0 0 0 .372-1.232 1.667 1.667 0 0 0-.194-.627Zm-7.8.474a1.002 1.002 0 0 1-.981-1.195 1.003 1.003 0 0 1 1.364-.729 1.001 1.001 0 0 1-.383 1.924Zm1-3.5c0 .133-.053.26-.146.354a.504.504 0 0 1-.354.146h-1a.504.504 0 0 1-.354-.146.504.504 0 0 1-.146-.354v-4c0-.133.053-.26.146-.354a.504.504 0 0 1 .354-.146h1c.133 0 .26.053.354.146a.504.504 0 0 1 .146.354v4Z"
          fill="#fff"
        />
      </g>
    </g>
    <defs>
      <clipPath id="not-found_svg__a">
        <rect width={196} height={196} rx={98} fill="#fff" />
      </clipPath>
      <clipPath id="not-found_svg__d">
        <path fill="#fff" transform="translate(123.5 128.5)" d="M0 0h16v16H0z" />
      </clipPath>
      <filter
        id="not-found_svg__b"
        x={-7.367}
        y={15.168}
        width={198.31}
        height={214.244}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={4} />
        <feGaussianBlur stdDeviation={4} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect1_dropShadow_8_43" result="effect2_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={12} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect2_dropShadow_8_43" result="effect3_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={28} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_8_43" result="effect4_dropShadow_8_43" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_8_43" result="shape" />
      </filter>
      <filter
        id="not-found_svg__c"
        x={3.797}
        y={5.397}
        width={204.578}
        height={228.25}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={1} />
        <feGaussianBlur stdDeviation={2} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.12 0" />
        <feBlend in2="BackgroundImageFix" result="effect1_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={8} />
        <feGaussianBlur stdDeviation={8} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect1_dropShadow_8_43" result="effect2_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={12} />
        <feGaussianBlur stdDeviation={16} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.04 0" />
        <feBlend in2="effect2_dropShadow_8_43" result="effect3_dropShadow_8_43" />
        <feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha" />
        <feOffset dy={24} />
        <feGaussianBlur stdDeviation={32} />
        <feColorMatrix values="0 0 0 0 0.113725 0 0 0 0 0.168627 0 0 0 0 0.207843 0 0 0 0.08 0" />
        <feBlend in2="effect3_dropShadow_8_43" result="effect4_dropShadow_8_43" />
        <feBlend in="SourceGraphic" in2="effect4_dropShadow_8_43" result="shape" />
      </filter>
    </defs>
  </svg>
);

export default SvgNotFound;
